<template>
  <div id="AboutMeClients" :class="sectionClass">
    <div class="uk-child-width-1-4 uk-grid-medium uk-text-center" uk-grid>
      <div v-for="n in 12">
        <img loading="lazy" width="80%" :src="`/static/about-me/b${n}.webp`" />
      </div>
    </div>
  </div>
</template>

<script>
import { isMobile } from '@/helpers'

export default {
  computed: {
    sectionClass() {
      return {
        section: !this.isMobile(),
        sectionMobile: this.isMobile(),
      }
    },
  },
  methods: {
    isMobile,
  },
}
</script>

<style lang="scss" scoped>
.section {
  width: 60%;
  margin-bottom: 12%;
}

.sectionMobile {
  width: 85%;
  margin-bottom: 12%;
}
</style>



// WEBPACK FOOTER //
// src/components/about-me/AboutMeClients.vue